// extracted by mini-css-extract-plugin
export default {"button":"Button_button__O+4gT","submit":"Button_submit__37N1P"};